import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';
import authApi from '../api/auth';
import   WOT_LOGO from '../assets/logos/World_O_Tutor.png';
import {
  BACK_ARROW,
  DEFAULT_PROFILE_PIC,
  FEEDBACK_ICON,
  LOGOUT_ICON,
  MESSAGE_SVG,
  NOTIFICATIONS_SVG,
  PERSON_ICON,
  RECEIPT_ICON,
  SETTINGS_ICON,

} from '../assets/icons';
import { useAppDispatch, useAppSelector } from '../hooks/useRedux';
import { login } from '../reducers/authSlice';
import { setUserProfile } from '../reducers/profileSlice';
import BottomNav from './BottomNav';
import BreadCrumb from './BreadCrumb';
import MenuDropDown from './MenuDropDown';
import xhr from '../utils/fetch';
import { MdLogout } from 'react-icons/md';
import { notificationsApi } from '../api/notifications';

function Header({
  sidebarOpen,
  onOpenSidebar,
  onCloseSidebar
}: {
  sidebarOpen: any;
  onOpenSidebar: any;
  onCloseSidebar: any;
}) {
  const [showHeader, setShowHeader] = useState({ show: true, scrollPos: 0 });
  const headerRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const { request } = useAppSelector((state) => state.profileSetupSlice);
  const { profile } = useAppSelector((state) => state.profileSlice);
  const userData = profile?._id ? profile : request;
  const { planId } = useParams();
  const navigate = useNavigate();
  const [path, setPath] = useState('');

  useEffect(() => {
    setPath(location.pathname);
  }, [location.pathname]);

  const handleScroll = () => {
    if (window.scrollY < 100) {
      setShowHeader(() => ({ ...showHeader, show: true }));
    } else {
      setShowHeader((prev) => ({
        scrollPos: document.body.getBoundingClientRect().top,
        show: document.body.getBoundingClientRect().top > prev.scrollPos
      }));
    }
  };

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const logout = async () => {
    await authApi.logout().catch((err) => err);
    dispatch(login(null));
    dispatch(setUserProfile(null));
  };

  const paths = [
    '/account/profile',
    '/account/transactions',
    '/account/settings',
    `/plans/${planId}/attendance`,
    '/inbox'
  ];

  if (paths.includes(path) && window.innerWidth < 768) {
    return (
      <div
        className={`fixed ${showHeader.show ? 'top-0' : '-top-20'
          } mx-auto container  transition-all w-full flex justify-center items-center h-16 bg-white p-4 drop-shadow-md fixed z-50`}
        ref={headerRef}
      >
        <div className=" w-full flex flex-row items-center">
          <div
            onClick={() => navigate(-1)}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-neutralBlue2 p-2 cursor-pointer"
          >
            <img src={BACK_ARROW} className="" />
          </div>
          <div className="px-4">
            <BreadCrumb />
          </div>
        </div>
      </div>
    );
  }

  if (sidebarOpen) {
    return (
      <div className="w-full h-full flex flex-col gap-4 my-[10%] px-7">
        <div className="flex items-start">
          <div className="w-20 h-20 rounded-full overflow-hidden">
            <img
              src={userData?.personal.data.profilePic || DEFAULT_PROFILE_PIC}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="w-full flex flex-col gap-1">
          <h3 className="text-2xl font-semibold">{userData?.personal.data.name}</h3>
          <p className="text-sm text-neutralGray2">{userData?.personal.data.email}</p>
        </div>
        <div className="container flex flex-col gap-7 justify-center mt-10">
          <Link to="/profile" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={PERSON_ICON} />
              <h3 className="text-base font-medium">Profile</h3>
            </div>
          </Link>
          <Link to="/account/transactions" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={RECEIPT_ICON} />
              <h3 className="text-base font-medium">Transactions and Receipts</h3>
            </div>
          </Link>
          <Link to="/account/settings" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={SETTINGS_ICON} />
              <h3 className="text-base font-medium">Settings</h3>
            </div>
          </Link>
          <Link to="/account/feedback" onClick={() => onCloseSidebar()}>
            <div className="flex items-center gap-4">
              <img src={FEEDBACK_ICON} />
              <h3 className="text-base font-medium">Share feedback</h3>
            </div>
          </Link>
          <div className="mt-20 flex items-center gap-4 cursor-pointer" onClick={() => logout()}>
            <img src={LOGOUT_ICON} alt="" className="w-4" />
            <p className="text-base font-medium">Logout</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`fixed ${showHeader.show ? 'top-0' : '-top-20'
          } mx-auto  transition-all w-full flex justify-center items-center h-16 bg-white p-4 drop-shadow-md fixed z-50`}
        ref={headerRef}
      >
        <div className=" w-full flex flex-row items-center justify-between container">
         <Link to='https://student.worldotutor.com'>
          <img src={WOT_LOGO} alt="WorldOTutor" className="max-w-56 w-full hidden md:flex items-center px-4" />
         </Link>
          <div className="px-4 lg:flex items-center justify-end hidden w-full gap-7">
            {profile?._id ? (
              <>
                <NavLink to={'/dashboard'}>Dashboard</NavLink>
                {/* <NavLink to={'/students'}>My Students</NavLink> */}
                {/* <NavLink to={'/calendar'}>My Calendar</NavLink> */}
                {/* <NavLink to={'/analytics'}>Analytics</NavLink> */}
                <MenuDropDown
                  options={[
                    {
                      id: 1,
                      name: 'My Students',
                      link: '/students'
                    },
                    {
                      id: 2,
                      name: 'My Plans',
                      link: '/plans'
                    }
                  ]}
                  title="My Students"
                />

                <MenuDropDown
                  options={[
                    {
                      id: 1,
                      name: 'My Calendar',
                      link: '/calendar'
                    },
                    {
                      id: 2,
                      name: 'My Attendance',
                      link: '/attendance'
                    }
                  ]}
                  title="My Calender"
                />
                <NavLink to={'/earnings'}>My Earnings</NavLink>
              </>
            ) : (
              <div className='flex items-center gap-4'>
                {location.pathname !== "/dashboard" &&
                  <NavLink to={'/dashboard'}>Go to Dashboard</NavLink>
                }
                <p className='hover:text-primary' onClick={() => logout()}>Logout</p>
              </div>

            )}
          </div>
          {profile?._id && (
            <div className="hidden md:flex gap-4 px-4">
              <Link to={'/inbox'}>
                <Inbox />
              </Link>
              <Link to={'/notifications'}>
                <Notifications />
              </Link>

              <Link to="/profile">
                <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
                  <img
                    src={
                      userData?.personal.data?.profilePic === ''
                        ? DEFAULT_PROFILE_PIC
                        : userData?.personal.data?.profilePic
                    }
                    alt="User Pic"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
              </Link>
            </div>
          )}

          <div className="md:hidden w-full flex justify-between gap-4 px-4 ">
            {profile?._id ?
              <>
                <div
                  onClick={() => onOpenSidebar()}
                  className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer"
                >
                  <img
                    src={
                      userData?.personal.data?.profilePic === '' ? DEFAULT_PROFILE_PIC : userData?.personal.data?.profilePic
                    }
                    alt="User Pic"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div className="flex gap-4 ml-auto">
                  <Link to={'/inbox'}>
                    <Inbox />
                  </Link>
                  <Link to={'/notifications'}>
                    <Notifications />
                  </Link>
                </div>
              </>
              :
              <div className='flex items-center gap-4 ml-auto'>
                {location.pathname !== "/dashboard" &&
                  <Link className='text-sm' to={'/dashboard'}>Go to Dashboard</Link>
                }
                <img onClick={() => logout()} src={LOGOUT_ICON} alt="" className="w-4" />
              </div>
            }

          </div>
        </div>
      </div >
      {!sidebarOpen && window.innerWidth < 768 && <BottomNav />
      }
    </>
  );
}
export const Inbox = () => {
  const [count, setCount] = useState(0);
  const { profile } = useAppSelector((state) => state.profileSlice);

  useEffect(() => {
    xhr({
      url: `/${profile?._id}/unread-messages`,
      method: 'GET'
    })
      .then((res) => {
        if (res.status === 'OK') {
          setCount(res.data);
        }
      })
      .catch((err) => err);
  }, []);

  return (
    <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
      <img src={MESSAGE_SVG} alt="message_svg" className="w-4" />
      {count > 0 ? (
        <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">
          {count}
        </span>
      ) : null}
    </div>
  );
};

function Notifications() {
  const [count, setCount] = useState(0);
  const { profile } = useAppSelector((state) => state.profileSlice);

  async function getUnReadNotifications(): Promise<any> {
    if (!profile?._id) return;
    return await notificationsApi.get(profile?._id).then((data) => data.filter((i: any) => i.read === false).length);
  }

  useEffect(() => {
    getUnReadNotifications()
      .then((data) => {
        setCount(data);
      })
      .catch((err) => err);
  }, []);

  return (
    <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
      <img src={NOTIFICATIONS_SVG} alt="message_svg" className="w-4" />
      {count > 0 ? (
        <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">
          {count}
        </span>
      ) : null}
    </div>
  )
}


export default Header;
